import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@18.19.86_db0@0.3.2_eslint@_k3azd7wwxbmm2i7jds4h6fw4h4/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}